var _rect, _rect2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32,
    rx: 5,
    fill: "#FFF0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32,
    rx: 5,
    fill: "#FFBDC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7293 21.2244V23.8331C15.7293 24.525 15.9881 25.1885 16.4488 25.6778C16.9095 26.167 17.5344 26.4418 18.1859 26.4418H28.0122C28.6637 26.4418 29.2885 26.167 29.7492 25.6778C30.2099 25.1885 30.4688 24.525 30.4688 23.8331V8.18096C30.4688 7.48909 30.2099 6.82556 29.7492 6.33634C29.2885 5.84711 28.6637 5.57227 28.0122 5.57227H18.6772C17.3205 5.57227 15.7293 6.74031 15.7293 8.18096V21.2244Z",
    fill: "#F54F59",
    stroke: "#F64E5B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3926 20.8739L5.54642 16.0043L10.3926 11.1348",
    stroke: "#F64E5B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9023 16.0039C21.9023 16.0039 12.3031 16.0039 6.15234 16.0039",
    stroke: "url(#paint0_linear_4013_12005)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4013_12005",
    x1: 16.882,
    y1: 16.0039,
    x2: 6.17203,
    y2: 16.0039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.153887,
    stopColor: "#FFBDC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153987,
    stopColor: "#F64E5B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.f285e129a5496b9d7d41750a948e142c.svg";
export { ForwardRef as ReactComponent };